import clamp from 'lodash/clamp';

import {Action, FlowsQueryEventEntry, SelectorTypeDefinitions} from 'common/query-builder/query-entry-section/types';
import {currentProjectStore} from 'common/report/stores/project-details';
import {ProjectFeatureFlag} from 'common/report/constants';

// eslint-disable-next-line import/no-cycle
import {SuperEntryRow} from '../super-entry';
import {FlowsEntryRowEl} from './template';
import {StepsType} from './components/number-of-steps-dropdown/types';

// Starting forward value for new flows entry rows is 3
export const STARTING_FORWARD_VALUE = 3;
export const OVERRIDE_STARTING_FORWARD_VALUE = 0;

/**
 * FlowsEntryRow implements flows report specific features in the query builder.
 *
 */
export class FlowsEntryRow extends SuperEntryRow {
  template = FlowsEntryRowEl;
  static getNewEntry(): FlowsQueryEventEntry {
    return {
      type: SelectorTypeDefinitions.FlowsEvent,
      event: {
        custom: false,
        id: null,
        label: `Select Step`,
        value: null,
      },
      forward: currentProjectStore.value?.hasFeatureFlag(ProjectFeatureFlag.FlowsLessDefaultSteps)
        ? OVERRIDE_STARTING_FORWARD_VALUE
        : STARTING_FORWARD_VALUE,
      filters: [],
    };
  }

  isIntermediatePlaceholder(): boolean {
    return this.isPlaceholder() && this.hasEventValue();
  }

  handleStepsMenuChange(ev: CustomEvent): void {
    const target = ev.currentTarget as HTMLElement;
    const dropdown = target.firstElementChild as HTMLElement;
    requestAnimationFrame(() => dropdown.focus());
  }

  handleStepsUpdate(ev: CustomEvent): void {
    if (ev.detail.type === StepsType.Before) {
      this.handleReverseStepsUpdate(ev.detail.steps);
    } else {
      this.handleForwardStepsUpdate(ev.detail.steps);
    }
  }

  handleReverseStepsUpdate(reverse: number): number {
    reverse = clamp(reverse, 0, 99);
    const delta = Math.abs(this.entry.reverse - reverse);
    const entry = {
      ...this.entry,
      reverse,
    };

    this.section.updateEntries(Action.EditFlowSteps, {entry, index: this.index, trackingProps: {reverse, delta}});
    return reverse;
  }

  handleForwardStepsUpdate(forward: number): number {
    forward = clamp(forward, 0, 99);
    const delta = Math.abs(this.entry.forward - forward);
    const entry = {
      ...this.entry,
      forward,
    };

    this.section.updateEntries(Action.EditFlowSteps, {entry, index: this.index, trackingProps: {forward, delta}});
    return forward;
  }
}
